import React, { useState } from 'react';
import { getLabel } from '../data/labels';
import { classIf } from '../data/utils/classIf';
import { filterBetsByNumberOfOdds } from '../data/utils/filterBetsByNumberOfOdds';
import { filtraParametriche } from '../data/utils/filtraParametriche';
import { getBetDescription } from '../data/utils/getBetDescription';
import { getConfiguration } from '../data/utils/configuration';
import { iconCategoryCssClass } from '../data/utils/iconCategoryCssClass';
import { iconSportCssClass } from '../data/utils/iconSportCssClass';
// import Odd from './Odd';
import Odd from '../common/Odd';
import { usePrematchData } from '../prematch/PrematchDataProvider';
import { parseWidgetData } from '../data/parseWidgetData';
import { useFetch } from '../data/fetch/useFetch';
import XRouterLink from '../common/seo/xrouter/XRouterLink';

function TopMatchesContent(props) {
    const prematchData = usePrematchData();
    const conf = getConfiguration();
    const data = props.data;
    const [selectedSport, setSelectedSport] = useState(0);


    if (!data || !data.length) {
        return <div>Nessun dato disponibile</div>;
        }


    const tournaments = data[selectedSport];
    

    // const sport = prematchData.sportById[sportId];
    // if (!sport) {
    // console.error(`Sport con ID ${sportId} non trovato`);
    // return null;
    // }
    // const desc = sport.descrizione;



    return (
        <>
            <div className="section-title l_2">
                <span className="title">{getLabel('prematch_page.widget.top_match')}</span>
                <div className="sport-switcher">
                    {data.map((tournaments, sportIndex) => {
                        const sportId = tournaments[0][0].sportRef;

                        function handleClick() {
                            setSelectedSport(sportIndex);
                        }

                        const sport = prematchData.sportById[sportId];
                        
                        const desc = sport.descrizione;
                        const icoSport = iconSportCssClass(sport.id, sport.iconClass);

                        return (
                            <div key={sportId} className={"selection-item l_2_1" + classIf(selectedSport === sportIndex, 'active selected')} onClick={handleClick}>
                                <div className={"icona-sport ico-sport l_2_1_1 " + icoSport}></div>
                                <span className="selection-item-desc l_2_1_2">{desc}</span>
                            </div>
                        );
                    })}
                </div>
            </div>
            {tournaments.map(matches => {
                const betsDescs = [];
                const renderedMatches = matches.map((m, i) => {
                    {/* function handleClick() {
                        const tournamentUniqueId = `${m.sportRef}_${m.categoryRef}_${m.tournamentRef}`;
                        prematchContext.openEvent(tournamentUniqueId, m);
                    } */}
                    let bets = filtraParametriche(m.bets);
                    bets = filterBetsByNumberOfOdds(bets);

                    return (
                        <React.Fragment key={m.uniqueId}>
                            <div className="match xs_tournamentEvent   accordion px-1 grid grid-cols-11 items-start bg-cs1 border-b border-b-cs7">
                                <div className="left-section sticky  py-1 pr-1 col-start-1 col-end-6 grid auto-rows-auto">
                                    <div className="time font-normal text-xxs text-cs9">
                                        <span>{m.dateShort}</span>
                                        <span>{m.time}</span>
                                    </div>
                                    <XRouterLink to={m.urlPath} data={m} state={m} className="w-full flex flex-col truncate">
                                    <div className="info w-full flex flex-col truncate">
                                        <div className="teams-inline w-full flex flex-col truncate" >
                                            <div className="team-home font-medium text-xs text-cs10 truncate">
                                                <span>{m.team1}</span>
                                            </div>
                                            {/* <div className="vs">-</div> */}
                                            <div className="team-away font-medium text-xs text-cs10 truncate mt-1">
                                                <span>{m.team2}</span>
                                            </div>
                                        </div>
                                    </div>
                                    </XRouterLink>
                                </div>
                                <div className=" top-matches odds xs_eventBetsContainer col-start-6 col-end-13 h-full pl-1 border-l border-l-cs7 ">
                                    {bets.map((b, betIndex) => {
                                        const isParametrica = b.parametrica;
                                       
                                        const oddsDescs = [];
                                        const renderedOdds = [];
                                   
                                        b.odds.forEach(odd => {
                                            if (i === 0) {
                                                oddsDescs.push(
                                                    <span key={odd.uniqueId} className="odd-desc">{odd.desc}</span>
                                                );
                                            }
                                            const id = `${m.id}_${odd.id}`;
                                            renderedOdds.push(
                                             <Odd key={odd.uniqueId} data={odd} />
                                            );
                                        });

                                        let nCols = b.odds.length;
                                        if (isParametrica) {
                                            nCols++;
                                        }

                                        const isEven = betIndex % 2 === 0;
                                        const hideable = betIndex;

                                        if (i === 0) {
                                            betsDescs.push(
                                                <div key={b.uniqueId} className="bets-header-item" data-odds={nCols} data-hideable={hideable}>
                                                    <div className={"bet-desc-container " + classIf(isEven, 'lighter')}>
                                                        <span className="bet-desc">{getBetDescription(b, true, m.sportRef)}</span>
                                                    </div>
                                                    <div className="odds-descs">
                                                        {isParametrica &&
                                                            <span className="odd-desc">{b.handicapTableDesc}</span>
                                                        }
                                                        {oddsDescs}
                                                    </div>
                                                </div>
                                            );
                                        }

                                        return (
                                            <React.Fragment key={b.uniqueId}>
                                                <div className='landing__odds-wrapper xs_scrollingBetsContainer py-1' data-hideable={hideable}>
                                                    {isParametrica &&
                                                        <div className={"bet flex flex-col" + classIf(isEven, 'lighter')} data-hideable={hideable}>
                                                            <span className="odd">{b.handicapDesc !== '' && b.handicapDesc !== '0' ? b.handicapDesc : <i className="fa fa-lock"></i>}</span>
                                                        </div>
                                                    }
                                                    <div className={"bet flex flex-row gap-[1px]" + classIf(isEven, 'lighter')} data-hideable={hideable}>
                                                        {renderedOdds}
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        );
                                    })}
                                </div>
                            </div>
                        </React.Fragment>
                    );
                });

                const m = matches[0];
                const categoryIcon = iconCategoryCssClass(m.sportRef, m.categoryRef, m.categoryIcon);

                return (
                    <div key={m.uniqueId} className="last-minute">
                        <div className="matches-container">
                            <div className="bets-header">
                                <div className="info-column-header xs_tournamentHeader z-20 sticky top-0 h-[70px] grid grid-cols-11 items-center bg-cs15 border-b border-b-cs1">
                                    <div className="sport-desc">
                                        <div className={"sport-icon " + categoryIcon} />
                                        <span className='font-bold text-sm text-cs10 truncate'>{matches[0].categoryDesc} - {matches[0].tournamentDesc}</span>
                                    </div>
                                    <div className="sub-header">
                                        <div className="time"></div>
                                        <div className="info"></div>
                                    </div>
                                </div>
                                {/* <div className="bets-header-descs">{betsDescs}</div> */}
                            </div>
                            {renderedMatches}
                        </div>
                    </div>
                );
            })}
        </>
    );
}

export default function TopMatches() {
    const prematchData = usePrematchData();
    // const data = useWidgets();
    const conf = getConfiguration();


    const [isLoading, isError, data] = useFetch(conf.api.getWidgetCentrali, null, (data) =>
        parseWidgetData(data, false)
    );
    
    if (isLoading || isError || data?.topMatches == null) {
        return null;
    }

    // if (data == null || nullOrEmptyObj(data.topMatches)) {
    //     return null;
    // }

    

    const sportsMap = new Map();
    data.topMatches.forEach(m => {
        if (!sportsMap.has(m.sportRef)) {
            sportsMap.set(m.sportRef, new Map());
        }

        const tMap = sportsMap.get(m.sportRef);

        const uniqueId = `${m.sportRef}_${m.categoryRef}_${m.tournamentRef}`;
        if (!tMap.has(uniqueId)) {
            tMap.set(uniqueId, []);
        }

        try {
            m.cRanking = prematchData.sportById[m.sportRef].categoryById[m.categoryRef].ranking;
            m.tRanking = prematchData.tournamentByUniqueId[uniqueId].ranking;
            tMap.get(uniqueId).push(m);
        } catch (e) {
            console.error(e);
        }
    });

    const sports = [];
    try {
        sportsMap.forEach(tMap => {
            const tournaments = Array.from(tMap.values());
            tournaments.sort((a, b) => {
                const [aMatch, bMatch] = [a[0], b[0]];
                if (aMatch.cRanking === bMatch.cRanking) {
                    if (aMatch.tRanking === bMatch.tRanking) {
                        return aMatch.timestampDB.localeCompare(bMatch.timestampDB);
                    }
                    return aMatch.tRanking - bMatch.tRanking;
                }
                return aMatch.cRanking - bMatch.cRanking;
            });

            // Sort matches by timestamp
            tournaments.forEach(matchesArray => {
                matchesArray.sort((a, b) => a.timestamp - b.timestamp);
            });
            sports.push(tournaments);
        });

        const sportById = prematchData.sportById;
        sports.sort((a, b) => {
            const [aSportId, bSportId] = [a[0][0].sportRef, b[0][0].sportRef];
            const aRanking = sportById[aSportId].ranking;
            const bRanking = sportById[bSportId].ranking;
            return aRanking - bRanking;
        });
    } catch (e) {
        console.error(e);
    }

    return (
        <TopMatchesContent data={sports} />
    );
}
